import React from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";
import { Row, Col, Button, Typography, Spin } from "antd"; 
import { Box } from "@mui/material";
import {
  EnvironmentOutlined,
  FolderOpenOutlined,
  RestOutlined,
  // 🆕 นำเข้าไอคอนใหม่แกะกล่องของ Ant Design มาเปลี่ยนสองอันกลาง
  FileProtectOutlined, 
  ContainerOutlined   
} from "@ant-design/icons";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

// Custom Hooks
import useAuthentication from "../Authen/Hooks/useAuthentication";
import useAuth from "../../hooks/useAuth";

export default function HomePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { verifyRole } = useAuthentication();

  if (!user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh', width: '100%' }}>
        <Spin size="large" tip="กำลังยืนยันสิทธิ์ผู้ใช้งานระบบ..." style={{ color: '#ffffff' }} />
      </Box>
    );
  }

  return (
    <Box
      id="sso-homepage-root"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        width: '100%',
        gap: 5,
        py: 4
      }}
    >
      {/* โซนหัวข้อประจำกอง */}
      <Row justify="center" style={{ width: '100%' }}>
        <Col span={24} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Typography style={{ fontWeight: "900", color: "#ffffff", fontSize: "2.8rem", marginBottom: '4px' }}>
            ระบบ Single Sign-On
          </Typography>
          <Typography style={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "1.3rem", fontWeight: 400 }}>
            กองสารสนเทศภาษีและทะเบียนทรัพย์สิน เทศบาลนครสุราษฎร์ธานี
          </Typography>
        </Col>
      </Row>

      {/* แผงรันปุ่มเมนู 6 สีปรับแต่งสองอันกลาง */}
      <Box sx={{ width: '100%', maxWidth: 1300, px: 2 }}>
        <Row gutter={[24, 24]} justify="center" className="row-button">
          
          {/* เมนูที่ 1: จัดการชื่อผู้ใช้งาน (สีเขียวเดิม) */}
          {verifyRole(user?.roles) === 1 && (
            <Col xs={24} sm={12} md={8} lg={4}>
              <Button
                type="primary"
                style={{ backgroundColor: "#4caf50", borderColor: "#388e3c", width: '100%' }}
                onClick={() => navigate("/usermanage")}
                className="size-button"
                icon={<ManageAccountsIcon />}
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <span>User Management</span>
                  <span style={{ fontSize: '0.75rem', fontWeight: 300 }}>(จัดการชื่อผู้ใช้งาน)</span>
                </div>
              </Button>
            </Col>
          )}

          {/* เมนูที่ 2: แผนที่ภูมิสารสนเทศ (สีเหลืองเดิม) */}
          <Col xs={24} sm={12} md={8} lg={4}>
            <Button
              type="primary"
              style={{ backgroundColor: "#e5b217", borderColor: "#e5b217", width: '100%' }}
              onClick={() => navigate("/map")}
              className="size-button"
            >
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <EnvironmentOutlined style={{ fontSize: 18, marginBottom: 4 }} />
                <span>Map</span>
                <span style={{ fontSize: '0.75rem', fontWeight: 300 }}>(แผนที่ภูมิสารสนเทศ)</span>
              </div>
            </Button>
          </Col>

          {/* 🟢 เมนูที่ 3 [ปรับปรุง]: ทะเบียนคุมแปลงที่ดิน (สว่างเด่นชัด ไม่จมหายไปกับพื้นหลัง) */}
          {(verifyRole(user?.roles) === 1 || verifyRole(user?.roles) === 2) && (
            <Col xs={24} sm={12} md={8} lg={4}>
              <Button
                type="primary"
                style={{ 
                  backgroundColor: "#00a8cc", // 🎨 ปรับสีฟ้าเทอร์ควอยซ์สว่าง
                  borderColor: "#00a8cc", 
                  width: '100%' 
                }}
                onClick={() => navigate("/landregistration")}
                className="size-button"
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <FileProtectOutlined style={{ fontSize: 20, marginBottom: 4 }} /> {/* 📦 เปลี่ยนไอคอนคุมสิทธิ์ที่ดิน */}
                  <span>TaxMap Registration</span>
                  <span style={{ fontSize: '0.75rem', fontWeight: 300 }}>(ทะเบียนคุมแปลงที่ดิน)</span>
                </div>
              </Button>
            </Col>
          )}

          {/* 🟢 เมนูที่ 4 [ปรับปรุง]: ซองเอกสารออนไลน์ (สีใหม่ สลับข้างไม่ซ้ำกับปุ่มส้มทะเบียนคุมซอง) */}
          {(verifyRole(user?.roles) === 1 || verifyRole(user?.roles) === 2) && (
            <Col xs={24} sm={12} md={8} lg={4}>
              <Button
                type="primary"
                style={{ 
                  backgroundColor: "#ff6f59", // 🎨 เปลี่ยนเป็นสีแดงปะการัง/ส้มพาสเทลเข้ม
                  borderColor: "#ff6f59", 
                  width: '100%' 
                }}
                onClick={() => navigate("/taxmapfolder")}
                className="size-button"
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <ContainerOutlined style={{ fontSize: 20, marginBottom: 4 }} /> {/* 📦 เปลี่ยนไอคอนชั้นตู้เก็บซองเอกสาร */}
                  <span>TaxMap Folders</span>
                  <span style={{ fontSize: '0.75rem', fontWeight: 300 }}>(ซองเอกสารออนไลน์)</span>
                </div>
              </Button>
            </Col>
          )}

          {/* เมนูที่ 5: ทะเบียนคุมซองรับเอกสาร (สีส้มเดิมของระบบ) */}
          {(verifyRole(user?.roles) === 1 || verifyRole(user?.roles) === 2) && (
            <Col xs={24} sm={12} md={8} lg={4}>
              <Button
                type="primary"
                style={{ backgroundColor: "#d5791f", borderColor: "#d5791f", width: '100%' }}
                onClick={() => navigate("/trackdoc/index")}
                className="size-button"
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <FolderOpenOutlined style={{ fontSize: 18, marginBottom: 4 }} />
                  <span>Track Documents</span>
                  <span style={{ fontSize: '0.75rem', fontWeight: 300 }}>(ทะเบียนคุมซอง)</span>
                </div>
              </Button>
            </Col>
          )}

          {/* เมนูที่ 6: ค่าธรรมเนียมการเก็บขยะ (สีม่วงเดิม) */}
          {(verifyRole(user?.roles) === 1 || verifyRole(user?.roles) === 4) && (
            <Col xs={24} sm={12} md={8} lg={4}>
              <Button
                type="primary"
                style={{ backgroundColor: "#791c89", borderColor: "#791c89", width: '100%' }}
                onClick={() => navigate("/wastefee")}
                className="size-button"
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <RestOutlined style={{ fontSize: 18, marginBottom: 4 }} />
                  <span>Waste Collection Fee</span>
                  <span style={{ fontSize: '0.75rem', fontWeight: 300 }}>(ค่าธรรมเนียมเก็บขยะ)</span>
                </div>
              </Button>
            </Col>
          )}

        </Row>
      </Box>
    </Box>
  );
}